<template>
  <div>
    <div class="canvas-box" ref="preMyChart"></div>
  </div>
</template>

<script>
export default {
  props: ["model", "result"],
  data() {
    return {
      weidu: [],
    };
  },
  mounted() {
    if (this.model) {
      this.renderMap();
    }
  },
  watch: {
    result(val) {
      this.renderMap();
    },
  },
  methods: {
    renderMap() {
      this.loadData();
      let myChart = this.$echarts.init(this.$refs["preMyChart"], null, {
        renderer: "svg",
      });
      let waiwei = 100 / this.weidu.length;
      let groups = [];
      let weidus = [];
      let indicators = [];
      let indicatorValues = [];
      let zhetuStyle = {
        image:
          "https://cdn.acmcoder.com/release/ceping/1.0.3/images/sanjiao.svg",
        width: 30,
        height: 65,
      };
      let zhetuStyle1 = {
        image:
          "https://cdn.acmcoder.com/release/ceping/1.0.3/images/sanjiao2.svg",
        width: 30,
        height: 65,
      };

      this.weidu.map((wd) => {
        let exists = groups.filter((g) => g.name == wd.group);
        if (exists.length == 0) {
          groups.push({
            name: wd.group,
            value: waiwei,
            itemStyle: wd.itemStyle,
          });
        } else {
          exists[0].value += waiwei;
        }
      });
      groups.map((gr) => {
        let wds = this.weidu.filter((wd) => wd.group == gr.name);

        wds.map((item) => {
          weidus.push({
            name: item.name,
            value: waiwei,
            itemStyle: item.itemStyle,
          });
        });

        wds.map((item, index) => {
          if (item.name == "i") {
            indicators.push({
              name: item.name,
              max: 10,
              axisLabel: { show: true },
            });
          } else {
            indicators.push({
              name: item.name,
              max: 10,
              axisLabel: { show: false },
            });
          }
        });

        wds.map((item) => {
          indicatorValues.push(item.value);
        });
      });
      let startAngle = 360 / this.weidu.length / 2;
      let option = {
        animation: false,
        radar: {
          radius: "55%",
          shape: "circle",
          splitNumber: 5,
          axisLabel: {
            show: true,
            color: "#333",
            showMinLabel: false,
          },

          startAngle: 90 + startAngle + 27,
          name: { show: false },
          splitLine: { show: true },
          indicator: indicators,
          radius: 97, //缩放
          center: ["50%", "50%"], //位置
        },

        graphic: {
          elements: [
            {
              type: "image",
              zlevel: 10,
              left: 220.2,
              top: 64,
              rotation: -5.22,
              style: zhetuStyle,
            },
            {
              type: "image",
              zlevel: 10,
              left: 277,
              top: 149,
              rotation: 2.21,
              style: zhetuStyle,
            },
            {
              type: "image",
              zlevel: 10,
              left: 278,
              top: 220,
              rotation: -6.8,
              style: zhetuStyle,
            },
            {
              type: "image",
              zlevel: 10,
              left: 160,
              top: 277,
              rotation: 6.59,
              style: zhetuStyle1,
            },
            {
              type: "image", //
              zlevel: 10,
              left: 97,
              top: 246,
              rotation: 6.0,
              style: zhetuStyle1,
            },
            {
              type: "image",
              zlevel: 10,
              left: 52,
              top: 156.3,
              rotation: 5.1,
              style: zhetuStyle1,
            },
            {
              type: "image",
              zlevel: 10,
              left: 111.7,
              top: 68.9,
              rotation: 4.1,
              style: zhetuStyle1,
            },
          ],
        },
        series: [
          {
            type: "radar",
            symbol: "none",
            radius: ["10%", "65%"],
            areaStyle: {
              color: "#69C5EF",
              opacity: 0.4, // 图形透明度
            },
            data: [
              {
                lineStyle: {
                  color: "#69C5EF",
                  type: "dashed",
                },
                value: indicatorValues.reverse(),
                label: { show: true, color: "black" },
              },
            ],
          },
          {
            type: "pie",
            radius: ["70%", "98%"],
            startAngle: 116,
            labelLine: {
              show: false,
            },
            label: {
              position: "inner",
              fontWeight: "bolder",
              color: "#fff",
              fontSize: 12,
            },
            data: groups,
          },
          {
            type: "pie",
            radius: ["55%", "69%"],
            // itemStyle: {
            //   borderRadius: [30, 0, 10, 0],
            //   // borderRadius: [0, 0, 20, 20],
            // },
            startAngle: 116,
            labelLine: {
              show: false,
            },
            label: {
              position: "inner",
              fontWeight: "bold",
              color: "#fff",
              fontSize: 12,
            },
            data: weidus,
          },
        ],
      };
      myChart.setOption(option);
    },
    loadData() {
      this.weidu = [
        {
          name: "a",
          group: "输出精力",
          value: this.result.a,
          itemStyle: {
            color: "#F76C6C",
            borderWidth: 0,
            borderColor: "#fff",
            // borderRadius: [0, 0, 20, 20],
          },
        },
        {
          name: "A",
          group: "输出精力",
          value: this.result.A,

          itemStyle: {
            color: "#F76C6C",

            borderColor: "#fff",
            borderWidth: 0,
          },
        },
        {
          name: "b",
          group: "输出精力",
          value: this.result.b,
          itemStyle: {
            color: "#F76C6C",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },
        {
          name: "B",
          group: "领导能力",
          value: this.result.B,
          itemStyle: {
            color: "#9977FD",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },
        {
          name: "c",
          group: "领导能力",
          value: this.result.c,
          itemStyle: {
            color: "#9977FD",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },
        {
          name: "C",
          group: "领导能力",
          value: this.result.C,
          itemStyle: {
            color: "#9977FD",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },

        {
          name: "D",
          group: "生活步调",
          value: this.result.D,
          itemStyle: {
            color: "#639DFD",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },
        {
          name: "E",
          group: "生活步调",
          value: this.result.E,
          itemStyle: {
            color: "#639DFD",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },
        {
          name: "d",
          group: "社交能力",
          value: this.result.d,
          itemStyle: {
            color: "#47E7BE",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },
        {
          name: "F",
          group: "社交能力",
          value: this.result.F,
          itemStyle: {
            color: "#47E7BE",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },
        {
          name: "e",
          group: "社交能力",
          value: this.result.e,
          itemStyle: {
            color: "#47E7BE",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },
        {
          name: "f",
          group: "社交能力",
          value: this.result.f,
          itemStyle: {
            color: "#47E7BE",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },

        {
          name: "H",
          group: "工作调整\n能力",
          value: this.result.H,
          itemStyle: {
            color: "#94E438",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },
        {
          name: "G",
          group: "工作调整\n能力",
          value: this.result.G,
          itemStyle: {
            color: "#94E438",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },
        {
          name: "J",
          group: "情绪稳定",
          value: this.result.J,
          itemStyle: {
            color: "#FFC333",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },
        {
          name: "g",
          group: "情绪稳定",
          value: this.result.g,
          itemStyle: {
            color: "#FFC333",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },
        {
          name: "I",
          group: "情绪稳定",
          value: this.result.I,
          itemStyle: {
            color: "#FFC333",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },
        {
          name: "h",
          group: "服从性",
          value: this.result.h,
          itemStyle: {
            color: "#F7825C",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },
        {
          name: "i",
          group: "服从性",
          value: this.result.i,
          itemStyle: {
            color: "#F7825C",
            borderWidth: 0,
            borderColor: "#fff",
          },
        },
        {
          name: "j",
          group: "服从性",
          value: this.result.j,
          itemStyle: {
            color: "#F7825C",
            borderWidth: 0,
            borderColor: "#fff",
          },
          // itemStyle1: {
          //   color: "#F7825C",
          //   borderWidth: 0,
          //   borderColor: "#fff",
          //   // borderRadius: [50, 0, 0, 0],
          // },
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.canvas-box {
  width: 400px;
  height: 400px;
  position: relative;
  margin: 0px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/echarts/personality/preLatitudeRadar.vue